import { useState } from "react";
import {
  ArrowLeftRight,
  PlusCircle,
  ThreeDotsVertical,
} from "react-bootstrap-icons";
import { useNavigate, useParams } from "react-router-dom";
import Table, { Column } from "../../../Components/Tables/Table";
import { inventoryoverviewdetailscompleted, inventoryoverviewdetailsinprogress, inventoryoverviewdetailsnew, inventoryOverviewList, transferoverviewcompletedlist, transferoverviewinprogresslist, transferoverviewlist } from "../../../Data/testData";
import PageHeader from "../../../Layout/PageHeader";
import Tabs from "../../../Shared/Tab/Tab";

export default function InventoryOverview() {
  const pageName = "Overview";
  const params = useParams();

  const navigation = useNavigate();

  const [isAddButtonDisable, setAddButtonDisable] = useState(false);
  const columns: Column[] = [
    
    {
      name: "ASN #",
      selector: (row: { asn: string }) => row.asn,
      enableSorting: true, // Enable sorting for this column
    },
    {
      name: "Supplier",
      selector: (row: { supplier: string }) => row.supplier,
      enableSorting: true, // Enable sorting for this column
    },
    {
      name: "ETA",
      selector: (row: { eta: string }) => row.eta,
      enableSorting: true, // Enable sorting for this column
    },
    {
      name: "Door",
      selector: (row: { door: string }) => row.door,
      enableSorting: true, // Enable sorting for this column
    },
    {
      name: "Lines",
      selector: (row: { lines: string }) => row.lines,
      enableSorting: true, // Enable sorting for this column
    },
    {
      name: "Received Qty",
      selector: (row: { receivedQty: string }) => row.receivedQty,
      enableSorting: true, // Enable sorting for this column
    },
    {
      name: "Putaway Qty",
      selector: (row: { putawayQty: string }) => row.putawayQty,
      enableSorting: true, // Enable sorting for this column
    },
    {
      name: "Status",
      selector: (row: { status: string }) => {
        return row.status === "new" ? (
          <span className="badge asn-overview-status w-70 asn-overview-status-border-blue">
            New
          </span>
        ) : row.status === "backorder" ? (
          <span className="badge text asn-overview-status w-70 asn-overview-status-border-red">
            Backorder
          </span>
        ) : row.status === "completed" ? (
          <span className="badge asn-overview-status w-70 asn-overview-status-border-green">
            Completed
          </span>
        ) : row.status === "ready to Check-in" ? (
          <span className="badge asn-overview-status w-70 asn-overview-status-border-blue">
            Ready to Check-in
          </span>
        ) : row.status === "ready to Unload" ? (
          <span className="badge asn-overview-status w-70 asn-overview-status-border-blue">
            Ready to Unload
          </span>
        ) : row.status === "ready to Receive" ? (
          <span className="badge asn-overview-status w-70 asn-overview-status-border-blue">
            Ready to Receive
          </span>
        ) : row.status === "in Progress" ? (
          <span className="badge asn-overview-status w-70 asn-overview-status-border-yellow">
            In Progress
          </span>
        ) : (
          <></>
        );
      },
    },
    {
      name: (
        <>
          <ArrowLeftRight
            className="me-2"
            style={{ stroke: "black", strokeWidth: 1 }}
          />
          <PlusCircle style={{ stroke: "black", strokeWidth: 1 }} />
        </>
      ),
      selector: () => (
        <>
          <span
            className="cursor-pointer dropdown-toggle action-menu border-none"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <ThreeDotsVertical />
          </span>
        </>
      ),
      enableSorting: false, // Disable sorting for this column
    },
  ];

  const handleRowClick = (data: any) => {
    navigation(`/inventory/overview/details/${data.invItemCode}`);
  };
  const handelSelectRows = (selectedRow: Set<number>) => {
    setAddButtonDisable(selectedRow.size > 0);
  };

  const onCurrentPageChange = (page: number) => {
    // Handle page change here if needed
    console.log('Page changed to:', page);
  };
  const tabs = [
    {
      order: 0,
      label: "New | " + inventoryoverviewdetailsnew.length,
      content: (
        <Table
          columns={columns}
          data={inventoryoverviewdetailsnew}
           pagination={{
          recordsPerPage: 15,
          totalRecords: inventoryoverviewdetailsnew.length,
          onCurrentPageChange: onCurrentPageChange
        }}
          CheckboxStatus={true}
        />
      ),
      visibility: true,
      status: true,
    },
    {
      order: 1,
      label: "In Progress | " + inventoryoverviewdetailsinprogress.length,
      content: (
        <Table
          columns={columns}
          data={inventoryoverviewdetailsinprogress}
           pagination={{
          recordsPerPage: 15,
          totalRecords: inventoryoverviewdetailsinprogress.length,
          onCurrentPageChange: onCurrentPageChange
        }}
          handleRowClick={handleRowClick}
          CheckboxStatus={true}
        />
      ),
      visibility: true,
      status: false,
    },
    {
      order: 2,
      label: "Completed | " + inventoryoverviewdetailscompleted.length,
      content: (
        <Table
          columns={columns}
          data={inventoryoverviewdetailscompleted}
           pagination={{
          recordsPerPage: 15,
          totalRecords: inventoryoverviewdetailscompleted.length,
          onCurrentPageChange: onCurrentPageChange
        }}
          handleRowClick={handleRowClick}
          CheckboxStatus={true}
        />
      ),
      visibility: true,
      status: true,
    },
  ];

  return (
    <>
      <PageHeader
        listUrl="/inventory/overview"
        name="Overview"
        isShowBackBtn={true}
      />
      <h5 className="text-start mt-1 mb-3">{pageName}</h5>
      <div className="d-flex gap-1 fw-bold">
        <span>
          <p>Item Code</p>
        </span>
        <span>
          {params?.["item-code"]?.split(":")[1] || "No item code provided"}
        </span>
      </div>
      <div>
        <Tabs tabs={tabs} isCheckbox={false} />
      </div>

      <div className="clearfix"></div>
      <div className="inbound-CheckIn-Table-Main-Div"></div>
      {/* <Table
        columns={columns}
        data={inventoryOverviewList}
         pagination={{
          recordsPerPage: 15,
          totalRecords: inventoryOverviewList.length,
          onCurrentPageChange: onCurrentPageChange
        }}
        onSelectedRowsChange={handelSelectRows}
        CheckboxStatus={true}
        enableSorting={true}
      /> */}
    </>
  );
}
